module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Italic.3ee014ee.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Italic.ttf
// module id = 526
// module chunks = 0